function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { T, useTranslate } from 'shared/helper/translate';
import { price } from 'researcher/helpers/price';
import { getChinaLocalization } from 'shared/account/reducer';
import Link from 'shared/components/Link';
import featureEnabled from 'shared/helper/feature';
import { recordServiceSelected } from 'researcher/helpers/gtm';
import trackRubriqEvent from 'rubriq/helpers/trackRubriqEvent';
import { getAvailableNewPlans, getPaddlePrices, isPaddlePricesLoading } from '../reducer';
import { PADDLE_PLAN_TYPES } from '../constants';
import iThenticate from '../images/ithenticate.svg';
var useClickableCard = function useClickableCard(id, setSelectedPlan, path) {
  var navigate = useNavigate();
  var goToPath = function goToPath() {
    if (!path) return;
    if (path.startsWith('http')) {
      window.location.href = path;
    } else {
      navigate(path);
    }
  };
  var handleClick = function handleClick(e) {
    if (e.target.closest('a,button')) return;
    if (path !== null && path !== void 0 && path.startsWith('http')) {
      goToPath();
      return;
    }
    setSelectedPlan(id);
    goToPath();
  };
  var handleKeyDown = function handleKeyDown(e) {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      if (e.target.closest('a,button')) return;
      setSelectedPlan(id);
      goToPath();
    }
  };
  return {
    handleClick: handleClick,
    handleKeyDown: handleKeyDown
  };
};
var EditingTranslationPlansRow = function EditingTranslationPlansRow(_ref) {
  var hasActivePlan = _ref.hasActivePlan;
  var user = useSelector(function (_ref2) {
    var user = _ref2.user;
    return user;
  });
  var _useSelector = useSelector(function (state) {
      return state;
    }),
    curie = _useSelector.curie;
  var _useTranslate = useTranslate(),
    t = _useTranslate.t;
  var isChinaUser = useSelector(getChinaLocalization);
  var needsCurrencyConversion = !isChinaUser;
  var enablePaddleCountryPrice = true;
  var paddlePrices = useSelector(getPaddlePrices);
  var loadingPaddlePrices = useSelector(isPaddlePricesLoading);
  var _React$useState = React.useState(null),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    selectedPlan = _React$useState2[0],
    setSelectedPlan = _React$useState2[1];
  var _useSelector2 = useSelector(getAvailableNewPlans),
    availablePremiumWithTranslationPlans = _useSelector2.premiumWithTranslation,
    availablePremiumWithEditingOnlyPlans = _useSelector2.editing,
    availablePlagiarismPlan = _useSelector2.plagiarism;
  var deepSeekEnabled = featureEnabled('rubriq_china_deep_seek');
  var ithenticateEnabled = featureEnabled('rubriq_plagiarism');
  var trialPlanUsed = curie === null || curie === void 0 ? void 0 : curie.alreadyTriedUser;
  var plans = {
    editing: {
      yearly: availablePremiumWithEditingOnlyPlans.find(function (plan) {
        return plan.billingInterval === PADDLE_PLAN_TYPES.YEARLY;
      }),
      monthly: availablePremiumWithEditingOnlyPlans.find(function (plan) {
        return plan.billingInterval === PADDLE_PLAN_TYPES.MONTHLY;
      })
    },
    translation: {
      yearly: availablePremiumWithTranslationPlans.find(function (plan) {
        return plan.billingInterval === PADDLE_PLAN_TYPES.YEARLY;
      }),
      monthly: availablePremiumWithTranslationPlans.find(function (plan) {
        return plan.billingInterval === PADDLE_PLAN_TYPES.MONTHLY;
      })
    },
    plagiarism: {
      plagiarismOneTimePayment: availablePlagiarismPlan
    }
  };
  var colClass = ithenticateEnabled ? 'col-3' : 'col-4';
  var getDisplayPrice = function getDisplayPrice(plan, fallbackPrice) {
    var divideMonthly = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    if (!enablePaddleCountryPrice) {
      return price(user.currency, fallbackPrice, true, needsCurrencyConversion);
    }
    if (loadingPaddlePrices) {
      return price(user.currency, fallbackPrice, true, needsCurrencyConversion);
    }
    var paddlePrice = paddlePrices[plan === null || plan === void 0 ? void 0 : plan.paddlePlanId];
    if (paddlePrice) {
      var amount = divideMonthly && (plan === null || plan === void 0 ? void 0 : plan.billingInterval) === PADDLE_PLAN_TYPES.YEARLY ? paddlePrice.amount / 12 : paddlePrice.amount;
      return "".concat(paddlePrice.currencySymbol).concat(amount.toFixed(2));
    }
    return price(user.currency, fallbackPrice, true, needsCurrencyConversion);
  };
  useEffect(function () {
    trackRubriqEvent('Pricing Page Viewed', {
      landing_page: window.location.pathname,
      user_email: (user === null || user === void 0 ? void 0 : user.email) || null,
      device: navigator.userAgent,
      has_active_plan: hasActivePlan,
      trial_plan_used: trialPlanUsed || false
    });
  }, []);
  var PricingInfo = function PricingInfo(_ref3) {
    var yearlyPlan = _ref3.yearlyPlan,
      monthlyPlan = _ref3.monthlyPlan;
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("p", {
      className: "pricing m-0 p-0 pb-1 fw-bold text-start"
    }, getDisplayPrice(yearlyPlan, (yearlyPlan === null || yearlyPlan === void 0 ? void 0 : yearlyPlan.price) / 12, true)), /*#__PURE__*/React.createElement("p", {
      className: "pricing-extra align-items-center text-start col-8 mb-1"
    }, /*#__PURE__*/React.createElement("span", {
      className: "fw-bold"
    }, getDisplayPrice(monthlyPlan, monthlyPlan === null || monthlyPlan === void 0 ? void 0 : monthlyPlan.price)), ' ', /*#__PURE__*/React.createElement(T, {
      source: "rubriq.annual-per-month-billing"
    })));
  };
  var PricingInfoForPlagiagrism = function PricingInfoForPlagiagrism(_ref4) {
    var amount = _ref4.amount,
      plan = _ref4.plan;
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("p", {
      className: "pricing m-0 p-0 pb-1 fw-bold text-start"
    }, getDisplayPrice(plan, amount)), /*#__PURE__*/React.createElement("p", {
      className: "pricing-extra align-items-center text-start col-8 mb-1"
    }, /*#__PURE__*/React.createElement(T, {
      source: "iThenticate_per_document"
    })));
  };
  var PlanCard = function PlanCard(_ref5) {
    var id = _ref5.id,
      title = _ref5.title,
      pricingComponent = _ref5.pricingComponent,
      featureList = _ref5.featureList,
      actionButton = _ref5.actionButton,
      description = _ref5.description,
      selectedPlan = _ref5.selectedPlan,
      setSelectedPlan = _ref5.setSelectedPlan,
      path = _ref5.path;
    var _useClickableCard = useClickableCard(id, setSelectedPlan, path),
      handleClick = _useClickableCard.handleClick,
      handleKeyDown = _useClickableCard.handleKeyDown;
    return /*#__PURE__*/React.createElement("div", {
      className: "".concat(colClass, " d-flex")
    }, /*#__PURE__*/React.createElement("div", {
      className: "card bg-white mt-4 mt-md-0 flex-grow-1 d-flex flex-column \n                ".concat(selectedPlan === id ? 'border-primary shadow' : ''),
      style: {
        cursor: 'pointer'
      },
      role: "button",
      tabIndex: 0,
      onClick: handleClick,
      onKeyDown: handleKeyDown
    }, /*#__PURE__*/React.createElement("div", {
      className: "card-body d-flex flex-column"
    }, /*#__PURE__*/React.createElement("div", {
      className: "callout rubriq-plan-header mb-1 font-weight-bold"
    }, /*#__PURE__*/React.createElement("h3", {
      className: "text-start"
    }, title), /*#__PURE__*/React.createElement("p", {
      className: "plan-text-description text-start text-muted"
    }, description)), pricingComponent, /*#__PURE__*/React.createElement("div", {
      className: "p-0 m-0 mt-3 rubriq-plan-feature-list"
    }, /*#__PURE__*/React.createElement("p", {
      className: "fw-bold"
    }, /*#__PURE__*/React.createElement(T, {
      source: "rubriq.features"
    })), featureList), /*#__PURE__*/React.createElement("div", {
      className: "pt-3 mt-auto d-flex justify-content-center"
    }, /*#__PURE__*/React.createElement("div", {
      className: "w-100"
    }, actionButton)))));
  };
  var PlagiarismPlanCard = function PlagiarismPlanCard(_ref6) {
    var id = _ref6.id,
      title = _ref6.title,
      pricingComponent = _ref6.pricingComponent,
      featureList = _ref6.featureList,
      actionButton = _ref6.actionButton,
      description = _ref6.description,
      subTitle = _ref6.subTitle,
      selectedPlan = _ref6.selectedPlan,
      setSelectedPlan = _ref6.setSelectedPlan,
      path = _ref6.path;
    var _useClickableCard2 = useClickableCard(id, setSelectedPlan, path),
      handleClick = _useClickableCard2.handleClick,
      handleKeyDown = _useClickableCard2.handleKeyDown;
    return /*#__PURE__*/React.createElement("div", {
      className: "".concat(colClass, " d-flex")
    }, /*#__PURE__*/React.createElement("div", {
      className: "card bg-white mt-4 mt-md-0 flex-grow-1 d-flex flex-column \n                ".concat(selectedPlan === id ? 'border-primary shadow' : ''),
      style: {
        cursor: 'pointer'
      },
      role: "button",
      tabIndex: 0,
      onClick: handleClick,
      onKeyDown: handleKeyDown
    }, /*#__PURE__*/React.createElement("div", {
      className: "card-body d-flex flex-column"
    }, /*#__PURE__*/React.createElement("div", {
      className: "callout rubriq-plan-header mb-1 font-weight-bold"
    }, /*#__PURE__*/React.createElement("h3", {
      className: "text-start"
    }, title), /*#__PURE__*/React.createElement("span", null, subTitle), /*#__PURE__*/React.createElement("p", {
      className: "plan-text-description text-start text-muted"
    }, description)), pricingComponent, /*#__PURE__*/React.createElement("div", {
      className: "p-0 m-0 mt-3 rubriq-plan-feature-list"
    }, /*#__PURE__*/React.createElement("p", {
      className: "fw-bold"
    }, /*#__PURE__*/React.createElement(T, {
      source: "rubriq.features"
    })), featureList), /*#__PURE__*/React.createElement("div", {
      className: "pt-3 mt-auto d-flex justify-content-center"
    }, /*#__PURE__*/React.createElement("div", {
      className: "w-100"
    }, actionButton)))));
  };
  var editingPlanCard = /*#__PURE__*/React.createElement(PlanCard, {
    id: "editing",
    path: "/rubriq/plan/subscribe/freetrial",
    selectedPlan: selectedPlan,
    setSelectedPlan: setSelectedPlan,
    title: /*#__PURE__*/React.createElement(T, {
      source: "curie.curie-premium"
    }),
    description: /*#__PURE__*/React.createElement(T, {
      source: "rubriq.plan-description"
    }),
    pricingComponent: /*#__PURE__*/React.createElement(PricingInfo, {
      yearlyPlan: plans.editing.yearly,
      monthlyPlan: plans.editing.monthly
    }),
    featureList: /*#__PURE__*/React.createElement(T.md, {
      source: "rubriq.premium-editing-feature-list"
    }),
    actionButton: /*#__PURE__*/React.createElement(Link, {
      id: "start_free_trial_btn_editing",
      "data-service-name": "Rubriq Premium",
      className: "btn btn-outline-primary w-100 w-md-auto d-flex align-items-center justify-content-center text-nowrap",
      to: "/rubriq/plan/subscribe/freetrial",
      onClick: function onClick() {
        recordServiceSelected({
          buttonId: 'start_free_trial_btn_editing',
          productName: 'Rubriq Premium'
        });
        trackRubriqEvent('Plan Selected', {
          planName: t('curie.curie-premium'),
          landing_page: window.location.pathname,
          user_email: (user === null || user === void 0 ? void 0 : user.email) || null,
          device: navigator.userAgent
        });
      }
    }, /*#__PURE__*/React.createElement("span", {
      className: "text-truncate"
    }, trialPlanUsed ? /*#__PURE__*/React.createElement(T, {
      source: "subscribe"
    }) : /*#__PURE__*/React.createElement(T, {
      source: "rubriq.get-starter"
    })))
  });
  var translationPlanCard = !hasActivePlan && /*#__PURE__*/React.createElement(PlanCard, {
    id: "translation",
    path: "/rubriq/plan/subscribe/premium",
    selectedPlan: selectedPlan,
    setSelectedPlan: setSelectedPlan,
    title: /*#__PURE__*/React.createElement(T, {
      source: "rubriq.rubriq-premium-with-translation"
    }),
    description: /*#__PURE__*/React.createElement(T, {
      source: "rubriq.plan-description"
    }),
    pricingComponent: /*#__PURE__*/React.createElement(PricingInfo, {
      yearlyPlan: plans.translation.yearly,
      monthlyPlan: plans.translation.monthly
    }),
    featureList: deepSeekEnabled ? /*#__PURE__*/React.createElement("div", {
      className: "p-0 m-0 mt-3 d-inline rubriq-plan-feature-list"
    }, /*#__PURE__*/React.createElement(T.md, {
      source: "rubriq.premium-with-translation-feature-list-deepseek"
    })) : /*#__PURE__*/React.createElement("div", {
      className: "p-0 m-0 mt-3 d-inline rubriq-plan-feature-list"
    }, /*#__PURE__*/React.createElement(T.md, {
      source: "rubriq.premium-with-translation-feature-list"
    })),
    actionButton: /*#__PURE__*/React.createElement(Link, {
      id: "start_free_trial_btn_translation",
      "data-service-name": "Rubriq Premium with Translation",
      className: "btn btn-outline-primary w-100 w-md-auto d-flex align-items-center justify-content-center text-nowrap",
      to: "/rubriq/plan/subscribe/premium",
      onClick: function onClick() {
        recordServiceSelected({
          buttonId: 'start_free_trial_btn_translation',
          productName: 'Rubriq Premium with Translation'
        });
        trackRubriqEvent('Plan Selected', {
          planName: t('rubriq.rubriq-premium-with-translation'),
          landing_page: window.location.pathname,
          user_email: (user === null || user === void 0 ? void 0 : user.email) || null,
          device: navigator.userAgent
        });
      }
    }, /*#__PURE__*/React.createElement("span", {
      className: "text-truncate"
    }, trialPlanUsed ? /*#__PURE__*/React.createElement(T, {
      source: "subscribe"
    }) : /*#__PURE__*/React.createElement(T, {
      source: "rubriq.get-starter"
    })))
  });
  var plagiarismPlanCard = !hasActivePlan && ithenticateEnabled && /*#__PURE__*/React.createElement(PlagiarismPlanCard, {
    id: "plagiarism",
    path: "/rubriq/plagiarism",
    selectedPlan: selectedPlan,
    setSelectedPlan: setSelectedPlan,
    title: /*#__PURE__*/React.createElement(T, {
      source: "plagiarism_check"
    }),
    subTitle: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(T, {
      source: "powered_by"
    }), " ", /*#__PURE__*/React.createElement("img", {
      src: iThenticate,
      alt: ""
    })),
    description: /*#__PURE__*/React.createElement(T, {
      source: "rubriq.plan-description"
    }),
    pricingComponent: /*#__PURE__*/React.createElement(PricingInfoForPlagiagrism, {
      amount: plans.plagiarism.plagiarismOneTimePayment[0].price,
      plan: plans.plagiarism.plagiarismOneTimePayment[0]
    }),
    featureList: /*#__PURE__*/React.createElement(T.md, {
      source: "plagiarism-feature-list"
    }),
    actionButton: /*#__PURE__*/React.createElement(Link, {
      className: "btn btn-outline-primary w-100 w-md-auto d-flex align-items-center justify-content-center text-nowrap",
      to: "/rubriq/plagiarism",
      state: {
        source: 'pricing_page'
      },
      onClick: function onClick() {
        return trackRubriqEvent('Plan Selected', {
          planName: t('plagiarism_check'),
          landing_page: window.location.pathname,
          user_email: (user === null || user === void 0 ? void 0 : user.email) || null,
          device: navigator.userAgent
        });
      }
    }, /*#__PURE__*/React.createElement("span", {
      className: "text-truncate"
    }, /*#__PURE__*/React.createElement(T, {
      source: "get_your_report_now"
    })))
  });
  var groupPlanCard = /*#__PURE__*/React.createElement(PlanCard, {
    id: "group",
    path: isChinaUser ? 'https://www.aje.cn/group-discounts' : 'https://www.aje.com/group-discounts',
    selectedPlan: selectedPlan,
    setSelectedPlan: setSelectedPlan,
    title: /*#__PURE__*/React.createElement(T, {
      source: "rubriq.preferred-group"
    }),
    description: /*#__PURE__*/React.createElement(T, {
      source: "rubriq.group-plan-description"
    }),
    pricingComponent: /*#__PURE__*/React.createElement("p", {
      className: "pricing m-0 p-0 pb-1 fw-bold text-center rubriq-plan-price"
    }, /*#__PURE__*/React.createElement(T, {
      source: "curie.custom"
    })),
    featureList: /*#__PURE__*/React.createElement(T.md, {
      source: "curie.preferred-group-feature-list"
    }),
    actionButton: /*#__PURE__*/React.createElement("a", {
      "aria-label": t('curie.contact-us'),
      className: "btn btn-outline-primary w-100",
      href: isChinaUser ? 'https://www.aje.cn/group-discounts' : 'https://www.aje.com/group-discounts'
    }, /*#__PURE__*/React.createElement(T, {
      source: "curie.contact-us"
    }))
  });
  return /*#__PURE__*/React.createElement("div", {
    className: "row pb-3 rubriq-plans-row rubriq-specific-font"
  }, editingPlanCard, translationPlanCard, ithenticateEnabled && plagiarismPlanCard, groupPlanCard);
};
export default EditingTranslationPlansRow;